import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const StarIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.16021 2.799C9.55421 2.18955 10.4458 2.18955 10.8398 2.799L12.8691 5.93802C13.0041 6.14674 13.2119 6.29773 13.4521 6.36156L17.0646 7.32157C17.766 7.50796 18.0415 8.3559 17.5836 8.91895L15.2253 11.819C15.0685 12.0118 14.9891 12.2561 15.0026 12.5043L15.2059 16.2366C15.2454 16.9613 14.5241 17.4853 13.8471 17.2239L10.3603 15.8772C10.1284 15.7876 9.87156 15.7876 9.63971 15.8772L6.15287 17.2239C5.47589 17.4853 4.75459 16.9613 4.79406 16.2366L4.99736 12.5043C5.01088 12.2561 4.9315 12.0118 4.77469 11.819L2.4164 8.91895C1.95854 8.3559 2.23405 7.50796 2.93542 7.32157L6.54791 6.36156C6.78811 6.29773 6.99593 6.14674 7.13087 5.93802L9.16021 2.799Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </SvgIcon>
  );
};
